import React from 'react';
import Button from '~/app/components/Button';
import AddFolderModal from './AddFolderModal';
import _ from 'shared/lib/gettext';

interface Props {
  onAddFolder: (folderName: string) => Promise<void>;
  showAddFolderModal: boolean;
  setShowAddFolderModal: (x: React.SetStateAction<boolean>) => void
}

export default function AddFolderButton(props: Props) {
  const { onAddFolder, showAddFolderModal, setShowAddFolderModal } = props;

  const createFolder = async (newFolderName) => {
    try {
      await onAddFolder(newFolderName);
    } catch (e) {
      console.error('Failed to add new folder', e);
    } finally {
      setShowAddFolderModal(false);
    }
  }

  return (
    <>
      <Button
        secondary
        onClick={() => { setShowAddFolderModal(true); }}
      >
        {_('ADD_FOLDER')}
      </Button>
      {
        showAddFolderModal &&
          <AddFolderModal
            onAddFolder={createFolder}
            onClose={() => { setShowAddFolderModal(false); }}
          />
      }
    </>
  );
}
